import { type Context, type Plugin } from "@nuxt/types";
import { type NuxtAxiosInstance } from "@nuxtjs/axios";

declare module "pinia" {
  export interface Pinia {
    _a: Context;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  export interface PiniaCustomProperties<Id, S> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $api: any;
    $store: Context["store"];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  export interface DefineStoreOptionsBase<S, Store> {
    // allow defining an api function
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    api?: (axios: NuxtAxiosInstance) => { [key: string]: any };
  }
}

const plugin: Plugin = ({ $pinia, store: $store, $axios }) => {
  $pinia.use(({ store, options }) => {
    // Standardized way to reset the store
    const initialState = JSON.parse(JSON.stringify(store.$state)); // deep clone
    if (!store.$reset) {
      store.$reset = () => {
        store.$patch(($state) => {
          Object.assign($state, initialState);
        });
      };
    }
    store.$api = options.api?.($axios);
    store.$store = $store;
  });
};

export default plugin;
